// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-search-gSVrzH{max-width:100%;border-radius:8px!important;width:256px!important}.ui-search-gSVrzH input::placeholder{color:var(--light-usage-text-color-text-3,rgba(28,29,35,.35))}.ui-search-gSVrzH input::placeholder{color:var(--light-usage-text-color-text-3,rgba(28,29,35,.35))}.ui-search-gSVrzH input::placeholder{color:var(--light-usage-text-color-text-3,rgba(28,29,35,.35))}.icon-search-gwA_ku{align-items:center;padding:0 8px 0 16px;display:flex}.icon-search-gwA_ku .active-Jrhgb7 svg{color:var(--light-usage-text-color-text-0,#1d1c23);transition:color .2s}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-search": `ui-search-gSVrzH`,
	"uiSearch": `ui-search-gSVrzH`,
	"icon-search": `icon-search-gwA_ku`,
	"iconSearch": `icon-search-gwA_ku`,
	"active": `active-Jrhgb7`
};
export default ___CSS_LOADER_EXPORT___;
